<template>
  <div ref="scroller" :class="['tva-scroller', orientation]">
    <div ref="foreground" class="foreground">
      <slot name="foreground"></slot>
    </div>
    <div ref="background" class="background">
      <slot name="background"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    threshold: {
      type: Number,
      default: 0.5,
    },
    top: {
      type: Number,
      default: 0.5,
    },
    bottom: {
      type: Number,
      default: 0.3,
    },
    fixedTop: {
      type: String,
      default: '0',
    },
    snap: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: true,
    },
    element: {
      type: HTMLDivElement,
      default: null,
    },
    orientation: {
      type: String,
      default: 'vertical',
    },
  },
  data() {
    return {
      index: 0,
      offset: 0,
      progress: -1,
      activeSections: [],
      delayedOffset: 0,
      delayedProgress: 0,
    }
  },
  watch: {
    progress(progress, oldProgress) {
      if (progress >= 0 && oldProgress >= 0) {
        this.$emit(
          'direction',
          progress > oldProgress ? 'foreward' : 'backward'
        )
      }
    },
    index() {
      // if (this.snap) this.debounce(this.scroll(), 1000);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.manage()
    })

    let element = this.element ? this.element : window
    element.addEventListener('resize', () => {
      this.manage()
    })

    element.addEventListener('scroll', () => {
      this.manage()
    })
    // this.computeProgress();
  },
  methods: {
    manage() {
      if (this.active) {
        this.allActions()
      } else {
        this.reset()
      }
    },
    allActions() {
      let dimension

      if (this.element) {
        dimension =
          this.orientation === 'vertical'
            ? this.element.getBoundingClientRect().height
            : this.element.getBoundingClientRect().width
      } else {
        dimension =
          this.orientation === 'vertical'
            ? window.innerHeight
            : window.innerWidth
      }

      const _treshold = dimension * this.threshold
      const _top = dimension * this.top
      const _bottom = dimension * this.bottom

      const foreground = this.$refs.foreground
      const background = this.$refs.background

      if (foreground) {
        const sections = foreground.childNodes

        let activeSections = []

        let foregroundTop = foreground.getBoundingClientRect()[
          this.orientation === 'vertical' ? 'top' : 'left'
        ]
        let computedForegroundTop = foregroundTop - _treshold
        let foregroundHeight = foreground.getBoundingClientRect()[
          this.orientation === 'vertical' ? 'height' : 'width'
        ]

        let progress = -computedForegroundTop / foregroundHeight

        this.$emit('progress', progress)
        this.progress = progress

        // Pin background
        if (background) {
          if (
            foregroundTop < _top &&
            -foregroundTop + _bottom < foregroundHeight
          ) {
            // Fixed
            background.style.position = 'fixed'
            background.style.top = this.fixedTop
            background.style.bottom = 'auto'
            background.style.left = 0
          } else if (foregroundTop >= _top) {
            // Not fixed top
            background.style.position = 'absolute'
            background.style.top = 0
            background.style.bottom = 'auto'
            background.style.left = 0
          } else if (-foregroundTop + _bottom >= foregroundHeight) {
            // Not fixed bottom
            background.style.position = 'absolute'
            background.style.top = 'auto'
            background.style.bottom = 0
            background.style.left = 0
          }
        }
        if (sections) {
          sections.forEach((section, index) => {
            let top =
              section.getBoundingClientRect()[
                this.orientation === 'vertical' ? 'top' : 'left'
              ] - _treshold
            let height = section.getBoundingClientRect()[
              this.orientation === 'vertical' ? 'height' : 'width'
            ]

            let offset = -top / height

            if (offset >= 0 && offset <= 1) {
              this.offset = offset
              this.index = index
              this.$emit('offset', offset)
              this.$emit('index', index)
            }

            // list of section in viewport
            if (
              section.getBoundingClientRect().top <
                window.innerHeight * this.bottom &&
              section.getBoundingClientRect().bottom >
                window.innerHeight * this.top
            ) {
              activeSections.push(index)

              this.$emit('activeSections', activeSections)
            }
          })
        }
      }
    },
    reset() {
      const background = this.$refs.background
      background.style.position = 'initial'
      background.style.top = 'initial'
      background.style.bottom = 'initial'
      background.style.left = 'initial'
    },
    computeProgress() {
      setInterval(() => {
        let tempOffset = this.offset - this.delayedOffset
        this.delayedOffset += tempOffset / 10
        this.$emit('delayedOffset', this.delayedOffset)

        let tempProgress = this.progress - this.delayedProgress
        this.delayedProgress += tempProgress / 10
        this.$emit('delayedProgress', this.delayedProgress)
      }, 50)
    },
    debounce(callback, wait, immediate = false) {
      let timeout = null

      return function () {
        const callNow = immediate && !timeout
        const next = () => callback.apply(this, arguments)

        clearTimeout(timeout)
        timeout = setTimeout(next, wait)

        if (callNow) {
          next()
        }
      }
    },
    scroll() {
      let el = document.querySelector(`#scroller-section-${this.index}`)
      el.scrollIntoView()
    },
  },
}
</script>

<style lang="scss" scoped>
.tva-scroller {
  position: relative;
  &.horizontal {
    .foreground {
      display: flex;
      flex-wrap: nowrap;
      width: fit-content;
    }
  }
}
</style>
